const Constants = {
    ROUTES: {
        AUTHENTICATION: '/login',
        SETUP_CONFIG: '/',
        DEPARTMENT_LIST: '/lists',
        EMPLOYEE_LIST: '/employees',
        SHIFT_LIST: '/shifts',
    },
    COLORS:{
        ORANGE:'orange'
    },
    API: {
        BASE_URL: window.location.origin + '/api/',
        TOKEN: {
            GET: 'token'
        },
        DEPARTMENT: {
            GET_ALL: 'lists'
        },
        EMPLOYEE: {
            GET_ALL: 'employees'
        },
        SHIFT: {
            GET_ALL: 'shifts'
        },
        SHIFT_DETAIL: {
            GET_SHIFT: 'shifts',
            UPDATE_TASK: 'checklists',
            UPDATE_SHIFT: 'shifts',
        },
        FETCH_TEAMS: "teams",
        FETCH_SPACES: "teams/{teamId}/space",
        FETCH_FOLDERS: "spaces/{spaceId}/folder",
        FETCH_LISTS: "folders/{folderId}/lists",
        FETCH_FOLDER_LESS_LISTS: "spaces/{spaceId}/lists"
    },
    PAGE_HEADER: {
        LOGIN: 'Sign In',
        SELECT_DEPT: 'Select List',
        SELECT_EMP: 'Who are you?',
        SELECT_SHIFT: 'Select Check List',
        ADD_ASSIGNEE:'Select a option to add',
        BTN_TOOL_TIP:'Click this button to close the checklist'
    },
    LOGIN_OPTIONS: [
        { text: 'Sign in with Clickup', logo: { path: '/images/clickup-symbol.svg', altText: 'clickup' } }
    ],
    HEADERS: {
        NOTES_FROM_MNGR: 'Notes from manager:',
        NOTES_FOR_MNGR: 'Notes for manager:',
        CONGRATS: 'Congratulations',
    },
    MESSAGE: {
        TODAY_YOU_WON: 'Today You Won',
        STARS: 'Stars',
        //    EXTRA_STAR_FOR:'Extra +1 Stars for leaving detailed Notes'
    },
    ERROR_MESSAGES: {
        SERVER_ERROR: 'Please enter valid verification code',
        ERR_NETWORK: 'Server down',
        INTERNAL_SERVER: 'Internal server error',
        SESSION_EXPIRED: 'Session expired',
    },
    SHIFT: {
        STATUS: {
            CLOSED: 'close',
            IN_REVIEW: 'in review'
        }
    },
    ACTIONS: {
        END_SHIFT: 'End your Shift',
        CLOSE:'Close'
    },
    ASSETS: {
        APP_LOGO: {
            PATH: '/images/check360-logo.svg',
            ALT_TEXT: 'Superior Stay'
        },
        CHECK_MARK_PENDING: {
            PATH: '/images/checkmark-grey-bg.png',
            ALT_TEXT: 'pending'
        },
        CHECK_MARK_COMPLETE: {
            PATH: '/images/green-checkmark-icon.svg',
            ALT_TEXT: 'complete'
        },
        ARROW_COLLASP: {
            PATH: '/images/down-arrow.png',
            ALT_TEXT: 'expand'
        },
        ARROW_EXPANDED: {
            PATH: '/images/expand-icon.svg',
            ALT_TEXT: 'collasp'
        },
        MEDAL: {
            PATH: '/images/medal.png',
            ALT_TEXT: 'Rating medal'
        },
        DONE: {
            PATH: '/images/done-button.png',
            ALT_TEXT: 'Done'
        },
    },
    RATING_CUSTOM_FIELD: {
        ID: "d5cbb4af-e3ca-4bb1-adad-9730c8a7dbdf",
    },
    CUSTOM_FIELDS: {
        NAME:{
            ASSIGNEE: 'Assignee'
        }
    },
    CREDENTIALS: {
        CLIENT_ID: '6MVJ18S3BGIZZXFA8DSNWNO00W654YL2'
    },
    REDIRECTION_URL: 'https://check360.hotel360.cloud'

}

export default Constants